import Bottomsheet from '@ixigo/iui/Bottomsheet';
import { Carousel, CarouselItem } from '@ixigo/iui/Carousel';
import { FC, Fragment } from 'react';
import BookingCard from '../BookingCard';
import BottomsheetHeader from '../BottomsheetHeader';
import { BookingCarouselProps } from './index.types';

const MobBookingCarousel: FC<BookingCarouselProps> = ({ bookings, onClick, recentBookings, setViewAll, viewAll }) => (
    <>
        <Carousel className='scroll-p-20'>
            {recentBookings.map((booking) => (
                <CarouselItem
                    key={booking.bookingId}
                    className='max-w-[85%] my-15 p-10 shadow-100 first-of-type:ml-20 last-of-type:mr-20'
                >
                    <BookingCard bookingData={booking} onClick={() => onClick(booking)} />
                </CarouselItem>
            ))}
        </Carousel>
        <Bottomsheet
            classes={{ container: '!min-w-full !max-h-[calc(100%-120px)]' }}
            onClose={() => setViewAll(false)}
            open={viewAll}
        >
            <BottomsheetHeader onClose={() => setViewAll(false)} title='Select your booking' />
            <div className='flex flex-col p-20 gap-15'>
                {bookings.map((booking) => (
                    <Fragment key={booking.bookingId}>
                        <div className='p-10 shadow-100 rounded-20'>
                            <BookingCard bookingData={booking} onClick={() => onClick(booking)} />
                        </div>
                    </Fragment>
                ))}
            </div>
        </Bottomsheet>
    </>
);

export default MobBookingCarousel;
